import React from 'react';
import { downloadAdminExport, downloadAdminConsentsCsvPage } from '../../diagnostics/export.js';

type ExportFormat = 'jsonl' | 'json' | 'csv';

export function ConsentsExportCard(props: {
  baseUrl: string;
  siteKey: string;
  from: string;
  to: string;
  bearer?: string;
}) {
  const { baseUrl, siteKey, from, to, bearer } = props;
  const [fmt, setFmt] = React.useState<ExportFormat>('jsonl');
  const [csvPage, setCsvPage] = React.useState(1);
  const [csvPageSize, setCsvPageSize] = React.useState(5000);

  return (
    <div className="rounded-lg border p-4 text-sm">
      <h2 className="text-lg font-semibold mb-2">Export Consent Events</h2>
      <div className="flex flex-wrap gap-2 items-end">
        <label className="flex flex-col">
          <span className="text-gray-600">Format</span>
          <select
            value={fmt}
            onChange={(e) => setFmt(e.target.value as ExportFormat)}
            className="border rounded px-2 py-1"
          >
            <option value="jsonl">JSONL</option>
            <option value="json">JSON</option>
            <option value="csv">CSV</option>
          </select>
        </label>
        <button
          className="px-3 py-1 rounded bg-blue-600 text-white"
          onClick={() =>
            downloadAdminExport({
              baseUrl,
              siteKey,
              fromIso: `${from}T00:00:00Z`,
              toIso: `${to}T23:59:59Z`,
              format: fmt,
              authToken: bearer,
            }).catch((e) => alert(String(e)))
          }
        >
          Download
        </button>
      </div>
      <p className="text-xs text-gray-500 mt-2">
        Includes gppString, sections, tcfString, gpc, region, timestamps.
      </p>
      <div className="mt-3 border-t pt-3">
        <div className="mb-2 font-medium">CSV (paged)</div>
        <div className="flex flex-wrap gap-2 items-end">
          <label className="flex flex-col">
            <span className="text-gray-600">Page</span>
            <input
              type="number"
              min={1}
              value={csvPage}
              onChange={(e) => setCsvPage(Math.max(parseInt(e.target.value || '1', 10) || 1, 1))}
              className="border rounded px-2 py-1 w-24"
            />
          </label>
          <label className="flex flex-col">
            <span className="text-gray-600">Page size</span>
            <input
              type="number"
              min={1}
              max={10000}
              value={csvPageSize}
              onChange={(e) =>
                setCsvPageSize(
                  Math.min(Math.max(parseInt(e.target.value || '5000', 10) || 5000, 1), 10000),
                )
              }
              className="border rounded px-2 py-1 w-28"
            />
          </label>
          <button
            className="px-3 py-1 rounded bg-indigo-600 text-white"
            onClick={() =>
              downloadAdminConsentsCsvPage({
                baseUrl,
                siteId: siteKey,
                fromIso: `${from}T00:00:00Z`,
                toIso: `${to}T23:59:59Z`,
                page: csvPage,
                pageSize: csvPageSize,
                authToken: bearer,
              }).catch((e) => alert(String(e)))
            }
          >
            Download CSV page
          </button>
        </div>
        <p className="text-xs text-gray-500 mt-2">
          Large windows may be clamped (X-Export-Range-Clamped=true). Total pages are provided on
          page 1.
        </p>
      </div>
    </div>
  );
}
